import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import type * as fhirTypes from "fhir/r4";

interface UpdateGenericObservationParams {
  fhirValue: {
    valueString: string;
  };
}

interface UpdateGenericObservationResponse {
  observation: fhirTypes.Observation;
}

export const useUpdateGenericObservation = ({
  observationId,
  patientId,
  encounterId,
}: {
  observationId?: string;
  patientId?: string;
  encounterId?: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<
    UpdateGenericObservationResponse,
    UpdateGenericObservationParams
  >({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chart.Observation.UPDATE_GENERIC({
        patientId,
        encounterId,
        observationId,
      }),
      mutationFn: (params) => {
        return axiosInstance.patch(
          `/charting/observation-generic/${observationId}`,
          params,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Observation.DEFAULT({
            patientId,
            encounterId,
          }),
        });

        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.Timeline.ENCOUNTER({
            patientId,
            motherEncounterId: encounterId,
          }),
        });
      },
    },
  });
};
